import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, StarContainer, Star, Count } from './styles';

const StarRating = ({ rating, withGrade = true, isReviewHeaderExpanded = false }) => {
  return (
    <Wrapper className="star-rating">
      {withGrade && <Count>{rating}</Count>}
      {[...Array(5)].map((_, index) => {
        index += 1;
        return (
          <StarContainer
            type="button"
            key={index}
            className={index <= rating ? 'on' : 'off'}
            isReviewHeaderExpanded={isReviewHeaderExpanded}
          >
            <Star isReviewHeaderExpanded={isReviewHeaderExpanded}>&#9733;</Star>
          </StarContainer>
        );
      })}
    </Wrapper>
  );
};

StarRating.propTypes = {
  rating: PropTypes.number.isRequired,
  withGrade: PropTypes.bool,
  isReviewHeaderExpanded: PropTypes.bool
};

export default StarRating;
